// This icon file is generated automatically.
var LaptopSimpleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M1.36 2.35v10.8h17.28V2.34H1.36zm7.84 15.3V14.5H.9a.9.9 0 01-.9-.9V1.9c0-.5.4-.9.9-.9h18.2c.5 0 .9.4.9.9v11.7c0 .5-.4.9-.9.9h-8.54v3.15H14A.68.68 0 1114 19H5.98a.68.68 0 01-.68-.67c0-.38.3-.68.68-.68H9.2z" } }] }, "name": "laptop-simple", "theme": "outlined" };
export default LaptopSimpleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/LaptopSimpleOutlined.js
// module id = 3008
// module chunks = 0